import styled from "styled-components";

const Header = styled.header`
  @import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.7.2/css/all.min.css");
  width: 100%;
  max-width: 100%;

  #header_wrap {
    font-family: "Roboto", sans-serif;
    font-weight: 400;
    letter-spacing: 0.5px;
    height: auto;
    margin: 0 auto;
    color: #fff;
    overflow: hidden;
    background-size: cover;
    background-repeat: no-repeat;
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
      max-width: 100%;
      position: fixed;
      width: 100%;
      top: 0;
      z-index: 1000;
      
    }
  }

  .header_top {
    height: 90px;
    width: 100%;
    max-width: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    background-color: #fff;
    color: #000;
    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      max-width: 100%;
    }

    .container_bg {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 100%;
      padding: 10px 0;
      border-radius: 10px;

      .contact_wrap {
        display: flex;
        align-items: center;
        gap: 30px;

        @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
          display: none;
        }
      }

      .site_branding {
        img {
          width: 150px;
          height: 150px;
        }
      }
      .animated_contact_info {
        display: flex;
        gap: 30px;
        margin-right: 30px;
      }
      .flex_icon {
        display: flex;
        align-items: center;
        p {
          font-size: 12px;
          line-height: 1.5;
          label {
            font-size: 10px;
            opacity: 0.5;
          }
        }
        a {
          color: ${({ theme }) => theme.color.blue};
          margin-right: 10px;
          width: 40px;
          height: 40px;
          border: 1px solid ${({ theme }) => theme.color.blue};
          border-radius: 50%;
          justify-content: center;
          align-items: center;
          display: flex;
          text-decoration: none;
          font-size: 12px;
        }
      }
      .social_icons {
        display: flex;
        gap: 13px;
        a {
          color: ${({ theme }) => theme.color.white};
          width: 25px;
          height: 25px;
          font-size: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          text-decoration: none;
          border-radius: 50%;
          background-color: ${({ theme }) => theme.color.ash};

          &:hover {
            background-color: ${({ theme }) => theme.color.blue};
          }
          background-color: #252525;
        }
      }
    }
  }

  .header_bottom {
    background-color: #252525;
    max-width: 100%;
    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      width: 100%;
      max-width: 100%;
    }
    .main_navigation {
      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        display: none;
      }
      ul {
        display: flex;
        gap: 50px;
        padding: 0;
        li {
          list-style: none;
          transition: background-color 0.3s;
          &:hover {
            background-color: ${({ theme }) => theme.color.red};
            cursor: pointer;
          }
          a {
            display: block;
            width: 100%;
            padding: 15px;
            text-decoration: none;
            text-transform: uppercase;
            font-size: 0.8rem;
            font-weight: bold;
            color: #fff;
            transition: color 0.3s;

            &.active {
              background-color: ${({ theme }) => theme.color.red};
            }
          }
        }
      }
    }
    .mobile_container {
      .open-menu {
        display: none;
        @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
          display: flex;
          i {
            font-size: 25px;
            padding: 15px 0;
          }
          max-width: 100%;
        }
      }
    }
    .mobile_navigation {
      ul {
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding: 0;
        li {
          list-style: none;
          transition: background-color 0.3s;
          &:hover {
            background-color: ${({ theme }) => theme.color.red};
            cursor: pointer;
          }
          a {
            display: block;
            width: 100%;
            padding: 15px;
            text-decoration: none;
            text-transform: uppercase;
            font-size: 0.8rem;
            font-weight: bold;
            color: #fff;
            transition: color 0.3s;

            &.mobile_active {
              color: ${({ theme }) => theme.color.red};
            }
          }
        }
      }
    }
  }
`;

export { Header };
